import { render } from "./Results.vue?vue&type=template&id=4fceefcc"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"

import "./Results.vue?vue&type=style&index=0&id=4fceefcc&lang=css"
script.render = render

export default script